<script lang="ts">
  import { mdiSwapHorizontal, mdiTrashCanOutline } from "@mdi/js"
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import InboxActionToggleCell from "../../../../../../_shared/_modules/inbox-action-toggle-cell"
  import type {
    WrongRecipientReplacementAction,
    WrongRecipientReplacementDraft,
    WrongRecipientReplacementRow,
  } from "../../contract"

  let props: InboxWorkflowCellProps<WrongRecipientReplacementRow, WrongRecipientReplacementDraft> =
    $props()

  const row = $derived(props.row)
  const draft = $derived(props.draft)
  const options = [
    { value: "replace", label: "Ersetzen", icon: mdiSwapHorizontal },
    { value: "remove", label: "Entfernen", icon: mdiTrashCanOutline, tone: "danger" as const },
  ]
</script>

<InboxActionToggleCell
  value={draft.action}
  {options}
  disabled={props.binding.disabled}
  ariaLabel={`Korrektur für ${row.customerLabel}`}
  wrap={true}
  allowEmptySelection={true}
  onChange={(next) =>
    props.patchDraft({
      action: (next === "replace" ? "replace" : "remove") as WrongRecipientReplacementAction,
    })}
/>
